export default "__VITE_ASSET__D$_MY8tf__";